import { Controller } from "@hotwired/stimulus"
import {get} from "@rails/request.js";

// Connects to data-controller="customize-url"
export default class extends Controller {
  static targets = ['urlContainer', 'editUrlContainer', 'customUrlField', 'errorWrapper', 'saveBtn']

  static values = {
    path: String,
    pathAvaliableMsg: String,
    pathFormateMsg: String,
    pathNotEmptyMsg: String,
    pathAlreadyTakenMsg: String,
    pathCheckingErrorMsg: String,
  }

  connect() {
    this.debounceTimeout = null  // Store timeout for debouncing
  }

  editUrl() {
    this.urlContainerTarget.classList.add('d-none')
    this.editUrlContainerTarget.classList.remove('d-none')
  }

  cancelEditUrl() {
    this.urlContainerTarget.classList.remove('d-none')
    this.editUrlContainerTarget.classList.add('d-none')
  }

  checkUrlFormat() {
    clearTimeout(this.debounceTimeout)

    const url = this.customUrlFieldTarget.value
    const urlRegex = /^[a-zA-Z0-9\-_]+$/
    if (!urlRegex.test(url)) {
      this.showMsg(this.pathFormateMsgValue, 'red')
      return
    }

    if (url === "") {
      this.showMsg(this.pathNotEmptyMsgValue, 'red')
      return
    }

    this.debounceTimeout = setTimeout(() => {
      this.clearError()
      this.verifyUrl(url)
    }, 500)
  }

  async verifyUrl(url) {
    let that = this
    try {
      const response = await get(this.pathValue, {
        query: {url},
        responseKind: "json"
      })

      if (response.ok) {
        const data = await response.json
        if (data.available) {
          this.clearError()
          this.showMsg(that.pathAvaliableMsgValue, 'green')  // Optional: display success message
        } else {
          this.showMsg(that.pathAlreadyTakenMsgValue, 'red')
        }
      } else {
        this.showMsg(that.pathCheckingErrorMsgValue, 'red')
      }
    } catch (error) {
      console.error("Error checking url:", error)
      this.showMsg("An error occurred. Please try again.", 'red')
    }
  }

  showMsg(message, color) {
    this.errorWrapperTarget.classList.remove('d-none')
    this.errorWrapperTarget.innerHTML = `<span class="mt-13px d-inline-block" style="color: ${color};">${message}</span>`
    this.saveBtnTarget.disabled= color == 'red'
  }

  clearError() {
    this.errorWrapperTarget.classList.add('d-none')
    this.errorWrapperTarget.innerHTML = ""
  }
}
